interface Translation {
  languageCode: string;
  value?: string;
  values?: string;
}

export const newSelectTranslation = (
  field?: Translation[],
  locale?: string,
  fallback = ''
): string => {
  if (locale) {
    const listTranslations = field?.find((f) => f.languageCode === locale);
    return listTranslations?.value || listTranslations?.values || fallback;
  }

  return field?.[0]?.value || field?.[0]?.values || fallback;
};
